<script>
  import Box from './Box.svelte';

  export let data_boxes
  export let step
  export let steps
</script>


<!-- {#each data_boxes as { headline, copy, position, size }, id} -->
{#each data_boxes as { headline, copy }, id}
  <Box 
    {headline}
    {copy}
    {id} 
    visible={step == id+1 || step == steps + id+1 }
    step={(step <= steps + id) ? 0 : 1}
  />
    <!-- {position} -->
    <!-- size={size ? size : {}} -->
  <!-- visible={id < step} -->
{/each}


<style>
</style>
